<button class="btn {{ type }}" type="{{typeAtributte}}" id="{{ id }}" [disabled]=disabled>
  {{ label }}
  <i *ngIf="icon" class="{{icon}} icon"></i>
</button>
